// extracted by mini-css-extract-plugin
export default {"switcher":"Switcher_switcher__AWKCu","on":"Switcher_on__lU5BK","off":"Switcher_off__NBnCC","slider":"Switcher_slider__h6337"};